export const BANNER_CTA_COUNT = 3;

export const nextBannerCtaIdx = (current: number): number => (current + 1) % BANNER_CTA_COUNT;
